/**
 * useShippingDiscount - Computes the shipping fee savings for badge display.
 *
 * When the actual shipping fee is 0 (free shipping), this hook returns
 * "Freeship" for display as a badge next to the applied coupon.
 *
 * Data source: useFastCartTotal hook (reads server-side FastCartTotals data).
 *
 * @returns "Freeship" label, or undefined if no shipping discount
 */

'use client';

import { useMemo } from 'react';
import { useFastCartTotal } from './use-fast-cart-total';

export const useShippingDiscount = (): string | undefined => {
    const { fastCartTotalsData } = useFastCartTotal();

    return useMemo(() => {
        const actualShippingAmount = fastCartTotalsData?.shipping_amount;

        // No data yet — no discount to show
        if (actualShippingAmount === undefined || actualShippingAmount === null) {
            return undefined;
        }

        // Show "Freeship" badge when actual shipping fee is 0 (free shipping)
        if (actualShippingAmount !== 0) {
            return undefined;
        }

        return 'Freeship';
    }, [fastCartTotalsData?.shipping_amount]);
};
